import type { AppEventMessage } from '@thermenresorts/bridge';
import type Constants from 'src/core/utils/Constants';

export type AuthenticateBridgeEvent = CustomEvent<AppEventMessage<typeof Constants.bridgeEventAuthenticate>>;

export const readAuthenticateAccessToken = (event: Event): string | undefined => {
	if (!('detail' in event)) {
		return undefined;
	}

	const detail: unknown = event.detail;

	if (typeof detail !== 'object' || detail === null || !('contents' in detail)) {
		return undefined;
	}

	const contents: unknown = detail.contents;

	if (typeof contents !== 'object' || contents === null || !('access_token' in contents)) {
		return undefined;
	}

	const accessToken: unknown = contents.access_token;

	return typeof accessToken === 'string' && accessToken.length > 0 ? accessToken : undefined;
};
